// Wraps the pod-resolved component + template pair into a single importable component
// for `.gts` consumers. Centralized here because `setComponentTemplate` may only be
// called once per class — inlining this in each consumer throws when more than one
// such module loads in the same test run.

// @ts-expect-error - need modern ember types
import { setComponentTemplate } from '@ember/component';

import PropagableSettingsChangedClass from './component';
// @ts-expect-error - no types for hbs imports
import propagableSettingsChangedHbs from './template';

// TODO add types for propagable settings changed component
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
const PropagableSettingsChanged = setComponentTemplate(propagableSettingsChangedHbs, PropagableSettingsChangedClass);

export default PropagableSettingsChanged;
